import React, { useEffect, useState } from "react";
import './RoundedCheckbox.scss';

type RoundedCheckboxType = {
    label: string,
    value: number,
    active?: boolean,
}

type RoundedCheckboxProps = {
    className?: string,
    label?: string,
    value: Array<number>,
    items: Array<RoundedCheckboxType>,
    disabled?: boolean,
    onChange: (value: Array<number>) => void,
};

function RoundedCheckbox(props: RoundedCheckboxProps) {

    const [activeValues, setActiveValues] = useState<Array<number>>(props.value);

    const handleChange = (value: number) => {
        const newValue = [...props.value];
        if(!newValue.includes(value)) {
            newValue.push(value);
        }
        else {
            newValue.splice(newValue.indexOf(value), 1);
        }
        
        props.onChange(newValue);
    };

    useEffect(() => {
        setActiveValues(props.value);
    }, [props.value]);

    return (
        <div className={`roundedcheckbox ${props.className ?? ''}`}>
            {props.label && (
                <span className="roundedcheckbox-label">{props.label}</span>
            )}
            <div className="roundedcheckbox-list">
                {props.items.map((item: RoundedCheckboxType, index: number) => (
                    <div key={index} className={`roundedcheckbox-item ${activeValues.includes(item.value) ? 'active' : ''}`} onClick={() => handleChange(item.value)}><span className="roundedcheckbox-item-label">{item.label}</span></div>
                ))}
            </div>
        </div>
    );
}

export default RoundedCheckbox;
